import { Injectable } from '@angular/core'
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs/Rx'
import 'rxjs/add/operator/do';
import { AppInsightsService } from '@markpieszak/ng-application-insights';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

    constructor(private appInsightsService: AppInsightsService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = JSON.parse(localStorage.getItem('dn-senac-seguranca'))["token"];

        const dummyrequest = req.clone({
            setHeaders: {
                'Authorization': 'Bearer ' + token,
                'content-type': 'application/json'
            }
        })
        return next.handle(dummyrequest);
    }
}



// WEBPACK FOOTER //
// ./src/app/header-interceptor.ts